import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyC7dB8GKpDpKtxNSwcpJFnc8cs1oWlfpOw",
    authDomain: "twitter-clone-1359f.firebaseapp.com",
    projectId: "twitter-clone-1359f",
    storageBucket: "twitter-clone-1359f.appspot.com",
    messagingSenderId: "34059387370",
    appId: "1:34059387370:web:6c2b754df6af86af9e3293",
    measurementId: "G-C9L7D89EW3"
  };

const  firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore();

export default db;